/** @jsxImportSource @emotion/react */
import * as React from "react";
import { OrganizationKeyName } from "../../model/Organization";
import { VenueListItem } from "../../model/VenueListItem";
import { routes } from "../../appRoutingHelpers";
import { TestIdsEnum } from "../../TestIdsEnum";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { InLineLabel } from "../../components/Label";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { TableRow } from "../../components/table-components/TableRow";
import { firstTableCellStyle } from "../../style-util";
import { Avatar } from "../../components/Avatar";

interface Props {
  organization: OrganizationKeyName;
  venue: VenueListItem;
  isActiveColVisible: boolean;
  isAddressColVisible: boolean;
  isImageColVisible: boolean;
  isTagsColVisible: boolean;
  isTitleColVisible: boolean;
  isEditActionVisible: boolean;
}

const VenueListRow: React.FC<Props> = (props) => {
  const venue = props.venue;
  const org = props.organization;
  const href = routes.venueEdit(org, venue.id);

  return (
    <TableRow data-test={TestIdsEnum.VenueListRow}>
      {props.isImageColVisible && (
        <TableCellLink href={href} css={firstTableCellStyle}>
          <Avatar size="small" imageUrl={venue?.image?.url} rounded={true}>
            {venue.title.charAt(0).toUpperCase()}
          </Avatar>
        </TableCellLink>
      )}
      {props.isTitleColVisible && (
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {venue.title}
          </StyledText>
        </TableCellLink>
      )}
      {props.isAddressColVisible && (
        <TableCellLink href={href}>
          <StyledText
            className="bodyTextRegular mb-0"
            color={colors.textPrimary}
          >
            {venue.address || "-"}
          </StyledText>
        </TableCellLink>
      )}
      {props.isTagsColVisible && (
        <TableCellLink href={href}>
          <div className="d-flex flex-row" style={{ gap: "8px" }}>
            {venue.tags && venue.tags.length > 0 ? (
              <>
                {venue.tags.map((t) => (
                  <InLineLabel
                    backgroundColor={colors.ctaInactive}
                    color={colors.textPrimary}
                    key={t}
                  >
                    {t}
                  </InLineLabel>
                ))}
              </>
            ) : (
              <StyledText
                className="bodyTextRegular mb-0"
                color={colors.textPrimary}
              >
                -
              </StyledText>
            )}
          </div>
        </TableCellLink>
      )}

      {props.isActiveColVisible && (
        <TableCellLink href={href} data-test-join-date-column="">
          {venue.isHidden ? (
            <InLineLabel
              backgroundColor={colors.errorLight}
              color={colors.errorDark}
            >
              Not visible
            </InLineLabel>
          ) : (
            <InLineLabel
              backgroundColor={colors.successLight}
              color={colors.successDark}
            >
              Visible
            </InLineLabel>
          )}
        </TableCellLink>
      )}
    </TableRow>
  );
};

export default VenueListRow;
